import qs from 'qs';
import axiosClient from './axiosClient';
import { serviceBase } from './serviceBase';

const getAllContracts = serviceBase({
  request: options =>
    axiosClient.get('/contracts', {
      params: options,
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      }
    }),
  retry: 0
});

export const createNewContract = serviceBase({
  request: value => axiosClient.post(`/contracts`, value)
});

export const cedeContract = serviceBase({
  request: value =>
    axiosClient.post(`/contracts/${value.contractId}/cession`, value)
});

export const resendSignRequestForContractCession = serviceBase({
  request: id => axiosClient.post(`/contract-cession/${id}/resend-sign-request`)
});

export const sendContractCessionToSign = serviceBase({
  request: id => axiosClient.post(`/contract-cession/${id}/send-to-sign`)
});

export const cancelContractCession = serviceBase({
  request: id => axiosClient.post(`/contract-cession/${id}/cancel`)
});

export const earlyTerminationContract = serviceBase({
  request: value =>
    axiosClient.post(`/contracts/${value.contractId}/early-termination`, value)
});

export const createNewContractDates = serviceBase({
  request: ({ id, values }) => {
    return axiosClient.post(`/contracts/edit-contract/${id}`, values);
  }
});

export const sendToSingContract = serviceBase({
  request: value => axiosClient.post(`/contracts/send-to-sign`, value)
});

export const singContractManually = serviceBase({
  request: ({ id, documentUrl }) =>
    axiosClient.post(`/contracts/${id}/sign-manually`, { documentUrl })
});

export const cancelContract = serviceBase({
  request: contract =>
    axiosClient.post(`/contracts/cancel-assignation`, contract)
});

export const getContractById = serviceBase({
  request: options =>
    axiosClient.get(`/contracts/${options.id}`, {
      params: { fullScheduleView: options.fullScheduleView }
    }),

  retry: 0
});

export const getBasicContractList = serviceBase({
  request: () => axiosClient.get('/contracts/basic-list'),
  retry: 0
});

export const getUpfrontRentNextPeriod = serviceBase({
  request: options =>
    axiosClient.get(`/contracts/${options.id}/next-upfront-rent`, {
      params: { fullScheduleView: options.fullScheduleView }
    }),

  retry: 0
});

export const getNextRentPeriod = serviceBase({
  request: options => axiosClient.get(`/contracts/${options.id}/next-rent`),

  retry: 0
});

export const getContractRentPeriods = serviceBase({
  request: contractId =>
    axiosClient.get(`/contracts/${contractId}/rent-periods`),
  retry: 0
});

export const getContractPaymentSchedule = serviceBase({
  request: options =>
    axiosClient.get(`/contracts/${options.id}/payment-schedule`, {
      params: { fullScheduleView: options.fullScheduleView }
    }),

  retry: 0
});

export const getRentBalanceSchedule = serviceBase({
  request: options =>
    axiosClient.get(`/contracts/${options.id}/rent-balance-schedule`, {
      params: { fullScheduleView: options.fullScheduleView }
    }),

  retry: 0
});

export const getFiscalInterestBalance = serviceBase({
  request: options =>
    axiosClient.get(`/contracts/balances/${options.id}/fiscal-interest-balance`),

  retry: 0
});

export const getFiscalCapitalBalance = serviceBase({
  request: options =>
    axiosClient.get(`/contracts/balances/${options.id}/fiscal-capital-balance`),

  retry: 0
});
export const simulateCapitalContribution = serviceBase({
  request: ({ contractId, amount }) =>
    axiosClient.post(
      `/contracts/capital-contribution/simulation/${contractId}`,
      {
        amount
      }
    ),
  retry: 0
});

export const getContractEvents = serviceBase({
  request: options => axiosClient.get(`/contracts/${options.id}/events`),

  retry: 0
});

export const updateSigleFile = serviceBase({
  request: file => axiosClient.put(`/aws`, file, { timeout: 120000 }),
  retry: 0
});

export const createCapitalContribution = serviceBase({
  request: value => axiosClient.post('/contracts/capital-contribution', value)
});

export const createCapitalContributionFromPayment = serviceBase({
  request: ({ paymentId, body }) =>
    axiosClient.post(
      `/santander/payment-reports/payments/${paymentId}/create-capital-contribution`,
      body
    ),
  retry: 0
});

export const getContributionsByContract = serviceBase({
  request: id => axiosClient.get(`/contracts/capital-contribution/${id}`),
  retry: 0
});

export const getAmendingAgreementDocList = serviceBase({
  request: id => axiosClient.get(`/contracts/amending-agreement/${id}`),
  retry: 0
});

export const getContractAvalList = serviceBase({
  request: id => axiosClient.get(`/contracts/${id}/aval`),
  retry: 0
});

export const getRentAfterContribution = serviceBase({
  request: ({ id, amount }) =>
    axiosClient.get(`/contracts/capital-contribution/rent/${id}`, {
      params: { amount }
    }),
  retry: 0
});

export const downloadContractPaymentSchedule = serviceBase({
  request: id =>
    axiosClient.get(`/contracts/${id}/payment-schedule/export`, {
      responseType: 'blob',
      timeout: 120000
    }),
  transformResponse: res => {
    try {
      const filename = 'Calendario De Pagos.xlsx';
      const a = document.createElement('a');
      a.href = window.URL.createObjectURL(res.data);
      a.download = filename;
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
    } catch (error) {
      console.log(`Opps, un error: ${error}`);
      console.error(error);
    }
  },
  retry: 0
});

export const downloadRentBalanceSchedule = serviceBase({
  request: id =>
    axiosClient.get(`/contracts/${id}/rent-balance-schedule/export`, {
      responseType: 'blob',
      timeout: 120000
    }),
  transformResponse: res => {
    try {
      const filename = 'Balance de Rentas.xlsx';
      const a = document.createElement('a');
      a.href = window.URL.createObjectURL(res.data);
      a.download = filename;
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
    } catch (error) {
      console.log(`Opps, un error: ${error}`);
      console.error(error);
    }
  },
  retry: 0
});

export const downloadFiscalInterestBalance = serviceBase({
  request: id =>
    axiosClient.get(`/contracts/balances/${id}/fiscal-interest-balance/export`, {
      responseType: 'blob',
      timeout: 120000
    }),
  transformResponse: res => {
    try {
      const filename = 'Balance de Intereses Fiscal.xlsx';
      const a = document.createElement('a');
      a.href = window.URL.createObjectURL(res.data);
      a.download = filename;
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
    } catch (error) {
      console.error(error);
    }
  },
  retry: 0
});

export const downloadFiscalCapitalBalance = serviceBase({
  request: id =>
    axiosClient.get(`/contracts/balances/${id}/fiscal-capital-balance/export`, {
      responseType: 'blob',
      timeout: 120000
    }),
  transformResponse: res => {
    try {
      const filename = 'Balance de capital fiscal.xlsx';
      const a = document.createElement('a');
      a.href = window.URL.createObjectURL(res.data);
      a.download = filename;
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
    } catch (error) {
      console.error(error);
    }
  },
  retry: 0
});
export const downloadFiscalCapitalBalanceWithContribution = serviceBase({
  request: ({ id, amount }) =>
    axiosClient.get(
      `/contracts/balances/${id}/fiscal-capital-balance/export-with-contribution`,
      {
        params: { amount },
        responseType: 'blob',
        timeout: 120000
      }
    ),
  transformResponse: res => {
    try {
      const filename = 'balance-fiscal-capital-con-aportacion.xlsx';
      const a = document.createElement('a');
      a.href = window.URL.createObjectURL(res.data);
      a.download = filename;
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
    } catch (error) {
      console.error(error);
    }
  },
  retry: 0
});

export const createContractFromQuoteRequest = serviceBase({
  request: value => axiosClient.post('/contracts/quote', value)
});

export const editContractById = serviceBase({
  request: ({ id, values }) => axiosClient.patch(`/contracts/${id}`, values)
});

export const updateContractPaydayRequest = serviceBase({
  request: ({ id, values }) =>
    axiosClient.patch(`/contracts/${id}/payday`, values)
});

export const getMonthlyRent = serviceBase({
  request: params => axiosClient.get('/contracts/rent', { params }),
  retry: 0
});

export const getSingleMsiDiscount = serviceBase({
  request: params => axiosClient.get('/contracts/msi-discount', { params }),
  retry: 0
});

export const activateContractAutomaticBilling = serviceBase({
  request: id =>
    axiosClient.patch(`/contracts/${id}/automatic-billing/activate`)
});

export const deactivateContractAutomaticBilling = serviceBase({
  request: id =>
    axiosClient.patch(`/contracts/${id}/automatic-billing/desactivate`)
});

export const createUpfrontRent = serviceBase({
  request: values =>
    axiosClient.post(`/contracts/${values.contractId}/upfront-rent`, values)
});

export const generateAutomaticDebitRequestDocument = serviceBase({
  request: contractId =>
    axiosClient.post(`/contracts/${contractId}/automatic-debit-request`)
});

export const sendToSignAutomaticDebitRequestDocument = serviceBase({
  request: contractId =>
    axiosClient.post(
      `/contracts/${contractId}/automatic-debit-request/send-to-sign`
    )
});

export const downloadContractList = serviceBase({
  request: options =>
    axiosClient.get(`/contracts/export`, {
      params: options,
      responseType: 'blob',
      timeout: 120000
    }),
  transformResponse: res => {
    try {
      const filename = 'Contratos.xlsx';
      const a = document.createElement('a');
      a.href = window.URL.createObjectURL(res.data);
      a.download = filename;
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
    } catch (error) {
      console.log(`Opps, un error: ${error}`);
      console.error(error);
    }
  },
  retry: 0
});

export const sendTerminationLetterToClient = serviceBase({
  request: id => axiosClient.post(`/contracts/${id}/termination-letter`)
});

export const getPayoffAmount = serviceBase({
  request: id => axiosClient.post(`/contracts/${id}/payoff-amount`)
});

export const resendSignRequestForAmendingAgreement = serviceBase({
  request: id =>
    axiosClient.post(`/contracts/${id}/amending-agreement/resend-signing-urls`)
});

export const sendToDraft = serviceBase({
  request: id => axiosClient.post(`/contracts/${id}/send-to-draft`)
});

export const generateTerminationLetter = serviceBase({
  request: id =>
    axiosClient.post(`/contracts/${id}/termination-letter/generate`, undefined, { timeout: 120000 })
});

export const terminateContract = serviceBase({
  request: id => axiosClient.post(`/contracts/${id}/terminate`)
});

export const updateContractPaymentMethod = serviceBase({
  request: ({ id, values }) =>
    axiosClient.post(`/contracts/${id}/payment-form`, values)
});

export const getAccountingCapitalBalance = serviceBase({
  request: ({ id }) =>
    axiosClient.get(`/contracts/balances/${id}/accounting-capital-balance`),
  retry: 0
});

export const getAccountingInterestBalance = serviceBase({
  request: ({ id }) =>
    axiosClient.get(`/contracts/balances/${id}/accounting-interest-balance`),
  retry: 0
});

export const downloadAccountingCapitalBalance = serviceBase({
  request: ({ id }) =>
    axiosClient.get(
      `/contracts/balances/${id}/accounting-capital-balance/export`,
      {
        responseType: 'blob',
        timeout: 120000
      }
    ),
  transformResponse: res => {
    try {
      const filename = 'Balance de capital contable.xlsx';
      const a = document.createElement('a');
      a.href = window.URL.createObjectURL(res.data);
      a.download = filename;
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
    } catch (error) {
      console.log(`Opps, un error: ${error}`);
      console.error(error);
    }
  },
  retry: 0
});

export const downloadAccountingInterestBalance = serviceBase({
  request: ({ id }) =>
    axiosClient.get(
      `/contracts/balances/${id}/accounting-interest-balance/export`,
      {
        responseType: 'blob',
        timeout: 120000
      }
    ),
  transformResponse: res => {
    try {
      const filename = 'Balance de interés contable.xlsx';
      const a = document.createElement('a');
      a.href = window.URL.createObjectURL(res.data);
      a.download = filename;
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
    } catch (error) {
      console.log(`Opps, un error: ${error}`);
      console.error(error);
    }
  },
  retry: 0
});

export default getAllContracts;
